import { Component, ViewChildren, QueryList } from '@angular/core';
import { AuthService } from '../../Services/auth.service';
// import * as $ from 'jquery';
import { HomeCardShowComponent } from '../home-card-show/home-card-show.component';
import { HomeCardCenterShowComponent } from '../home-card-center-show/home-card-center-show.component';
// import { ChildrenOutletContexts } from '@angular/router';

@Component({
    selector: 'home',
    template: require('./home.component.html'),
    styles: [require('./home.component.css')]
})
export class HomeComponent {
    @ViewChildren(HomeCardShowComponent) children: QueryList<HomeCardShowComponent>;
    @ViewChildren(HomeCardCenterShowComponent) CenterChildren: QueryList<HomeCardCenterShowComponent>;

    constructor(private auth:AuthService){
        
    }
    
    ngOnInit(){
       this.refreshAll();
    }

    ngAfterViewInit(){
        this.refreshAll();
    }

    refreshAll(){
        if (this.children != null){
            this.children.forEach((c)=>c.refreshAll())
        }
        if (this.CenterChildren != null){
            this.CenterChildren.forEach( (c) => c.refreshAll() )
        }
    }

    doLogin(){
        this.auth.login();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/home/home.component.ts